import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=53b887ec&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"
import style0 from "./Step3.vue?vue&type=style&index=0&id=53b887ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b887ec",
  null
  
)

export default component.exports